/* ═══════════════════════════════════════════
   WINGOMART HOME — wingomart-home.js
   ═══════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── ADD TO CART ── */
  function wmAddToCart(btn, variantId) {
    var orig = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      btn.textContent = 'Added ✓';
      btn.style.background = '#059669';
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        var counters = document.querySelectorAll('.cart-count-bubble, .cart__count, [data-cart-count], .wm-cart-count');
        counters.forEach(function(el) { el.textContent = cart.item_count; });
      });
      setTimeout(function() {
        btn.textContent = orig;
        btn.style.background = '';
        btn.disabled = false;
      }, 2200);
    })
    .catch(function() {
      btn.textContent = 'Error — retry';
      btn.disabled = false;
      setTimeout(function() { btn.textContent = orig; }, 2000);
    });
  }
  window.wmAddToCart = wmAddToCart;

  /* ── STATS COUNTER ANIMATION ── */
  function animateCount(el, target, suffix, duration) {
    var start = 0;
    var startTime = null;
    var isFloat = target % 1 !== 0;
    function step(ts) {
      if (!startTime) startTime = ts;
      var progress = Math.min((ts - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = eased * target;
      el.textContent = (isFloat ? current.toFixed(1) : Math.floor(current).toLocaleString()) + suffix;
      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = (isFloat ? target.toFixed(1) : target.toLocaleString()) + suffix;
    }
    requestAnimationFrame(step);
  }

  function initStats() {
    var stats = document.querySelectorAll('.wm-stat__num[data-target]');
    if (!stats.length) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var target = parseFloat(el.dataset.target);
          var suffix = el.dataset.suffix || '';
          animateCount(el, target, suffix, 1800);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.4 });
    stats.forEach(function(el) { observer.observe(el); });
  }

  /* ── FAQ ACCORDION ── */
  function initFaq() {
    var triggers = document.querySelectorAll('.wm-faq-item__trigger');
    triggers.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.wm-faq-item');
        var isOpen = item.classList.contains('is-open');
        document.querySelectorAll('.wm-faq-item.is-open').forEach(function(open) {
          open.classList.remove('is-open');
        });
        if (!isOpen) item.classList.add('is-open');
      });
    });
    var first = document.querySelector('.wm-faq-item');
    if (first) first.classList.add('is-open');
  }

  /* ── BEFORE / AFTER SLIDER ── */
  function initBA() {
    var wrap = document.querySelector('.wm-ba__slider-wrap');
    if (!wrap) return;
    var before   = wrap.querySelector('.wm-ba__before');
    var divider  = wrap.querySelector('.wm-ba__divider');
    var dragging = false;

    function setPos(pct) {
      pct = Math.max(5, Math.min(95, pct));
      before.style.clipPath  = 'inset(0 ' + (100 - pct) + '% 0 0)';
      divider.style.left = pct + '%';
    }

    function getPercent(e) {
      var rect = wrap.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      return (x / rect.width) * 100;
    }

    divider.addEventListener('mousedown',  function() { dragging = true; });
    divider.addEventListener('touchstart', function() { dragging = true; }, { passive: true });
    window.addEventListener('mouseup',   function() { dragging = false; });
    window.addEventListener('touchend',  function() { dragging = false; });
    window.addEventListener('mousemove', function(e) { if (dragging) setPos(getPercent(e)); });
    window.addEventListener('touchmove', function(e) { if (dragging) setPos(getPercent(e)); }, { passive: true });
    setPos(50);
  }

  /* ── NEWSLETTER FORM ── */
  function initNewsletter() {
    var form = document.querySelector('.wm-newsletter__form-el');
    if (!form) return;
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var input  = form.querySelector('.wm-newsletter__input');
      var submit = form.querySelector('.wm-newsletter__submit');
      var email  = input.value.trim();
      if (!email || !email.includes('@')) {
        input.style.border = '2px solid #dc2626';
        setTimeout(function() { input.style.border = ''; }, 1500);
        return;
      }
      submit.textContent = 'Subscribing...';
      submit.disabled    = true;
      setTimeout(function() {
        var parent = form.closest('.wm-newsletter__inner');
        var msg    = parent.querySelector('.wm-newsletter__success');
        if (msg) {
          form.style.display = 'none';
          msg.style.display  = 'block';
        } else {
          submit.textContent = '🎉 You\'re in!';
          submit.style.background = '#059669';
        }
      }, 900);
    });
  }

  /* ── SCROLL REVEAL ── */
  function initReveal() {
    if (!window.IntersectionObserver) return;
    var style = document.createElement('style');
    style.textContent = [
      '.wm-reveal { opacity:0; transform:translateY(24px); transition:opacity 0.55s ease, transform 0.55s ease; }',
      '.wm-reveal.is-visible { opacity:1; transform:none; }',
      '.wm-reveal-delay-1 { transition-delay:0.08s; }',
      '.wm-reveal-delay-2 { transition-delay:0.16s; }',
      '.wm-reveal-delay-3 { transition-delay:0.24s; }',
      '.wm-reveal-delay-4 { transition-delay:0.32s; }'
    ].join('');
    document.head.appendChild(style);

    var els = document.querySelectorAll('.wm-why-card, .wm-review, .wm-card, .wm-cat, .wm-faq-item, .wm-feature-item, .wm-stat');
    els.forEach(function(el, i) {
      el.classList.add('wm-reveal');
      if (i % 4 === 1) el.classList.add('wm-reveal-delay-1');
      if (i % 4 === 2) el.classList.add('wm-reveal-delay-2');
      if (i % 4 === 3) el.classList.add('wm-reveal-delay-3');
    });

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    els.forEach(function(el) { observer.observe(el); });
  }

  /* ── INIT ALL ── */
  function init() {
    initStats();
    initFaq();
    initBA();
    initNewsletter();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();